(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xltd-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('xltd-slideshow')) {
  customElements.define('xltd-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.x-gallery-track');
      this.slides = [...this.querySelectorAll('.x-gallery-slide')];
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.visible = false;
      this.toggle = this.querySelector('[data-toggle]');
      const controls = this.querySelector('.x-slide-controls');
      if (controls) controls.hidden = false;
      this.querySelector('[data-prev]')?.addEventListener('click', () => { this.pause(); this.go(this.index - 1); }, options);
      this.querySelector('[data-next]')?.addEventListener('click', () => { this.pause(); this.go(this.index + 1); }, options);
      this.toggle?.addEventListener('click', () => { this.playing = !this.playing; this.update(); }, options);
      this.track.addEventListener('keydown', event => {
        const keys = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in keys) || event.target !== this.track) return;
        event.preventDefault(); this.pause(); this.go(keys[event.key]);
      }, options);
      this.track.addEventListener('pointerdown', () => this.pause(), options);
      this.track.addEventListener('scroll', () => {
        const left = this.track.getBoundingClientRect().left;
        this.index = this.slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left-left) < Math.abs(this.slides[best].getBoundingClientRect().left-left) ? i : best, 0);
        const count = this.querySelector('[data-current]'); if (count) count.textContent = this.index + 1;
      }, { ...options, passive: true });
      this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: .15 });
      this.observer.observe(this);
      this.addEventListener('click', event => {
        const trigger = event.target.closest('.x-gallery-open'); if (!trigger) return;
        const dialog = document.getElementById(trigger.dataset.dialog); if (!dialog) return;
        this.pause(); const img = document.createElement('img'); img.src = trigger.dataset.image; img.alt = trigger.dataset.alt || '';
        dialog.querySelector('.x-gallery-enlarged').replaceChildren(img); dialog.showModal();
      }, options);
      this.update();
    }
    go(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    pause() { this.playing = false; this.update(); }
    update() { if (this.toggle) this.toggle.textContent = this.playing ? this.dataset.pause : this.dataset.play; this.schedule(); }
    schedule() {
      clearTimeout(this.timer);
      if (!this.playing || !this.visible || this.hovering || this.focused || document.hidden || this.slides.length < 2) return;
      this.timer = setTimeout(() => { this.go(this.index + 1); this.schedule(); }, Number(this.dataset.interval) || 6000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.abort?.abort(); this.abort = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xltd-header"]) return;
  try {
    
if (!customElements.get('xltd-category-navigation')) {
  customElements.define('xltd-category-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const groups = Array.from(this.querySelectorAll('.x-category-group'));
      const disclosures = groups.map(group => group.querySelector('details'));
      const closeOthers = active => disclosures.forEach(details => {
        if (details !== active) details.open = false;
      });
      groups.forEach(group => {
        const details = group.querySelector('details');
        const summary = details.querySelector('summary');
        group.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover) and (min-width: 751px)').matches) return;
          closeOthers(details);
          details.open = true;
        }, options);
        group.addEventListener('pointerleave', event => {
          if (event.pointerType === 'mouse' && !group.contains(document.activeElement)) details.open = false;
        }, options);
        group.addEventListener('focusout', event => {
          if (!group.contains(event.relatedTarget)) details.open = false;
        }, options);
        summary.addEventListener('click', () => {
          if (!details.open) closeOthers(details);
        }, options);
        group.addEventListener('keydown', event => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            details.open = false;
            summary.focus();
          }
        }, options);
      });
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) closeOthers(null);
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
